import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientStudentGroups = async ({ rootGetters }, { clientSid, queryParam }) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.getClientStudentGroups(clientSid, queryParam);
  return response;
};
